<template>
  <div>
    <div>
      <SearchAndFilter
        @pagination="update"
        @onTextChange="onTextChange"
        :searchAndFilter="searchAndFilter"
        :onActiveFilterChange="onActiveFilterChange"
        :advertiserList="advertiserList"
      />
      <v-data-table
        :headers="headers"
        :items="advertiserList.items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr
            @click="
              goToAdvertiserReportPage(props.item.agencyId, props.item.id)
            "
          >
            <td
              :class="{ inactive: !isActive(props.item) }"
              class="text-xs-center pointer"
            >
              <AppStatus
                :class="{ inactive: !isActive(props.item) }"
                :value="props.item.status"
                @click="onClick($event, props.item.id)"
                :readonly="!hasAdminPermission(props.item)"
                color="info"
                with-icon
              />
            </td>
            <td
              :class="{ inactive: !isActive(props.item) }"
              class="text-xs-center pointer"
            >
              {{ props.item.anAdvertiserId }}
            </td>
            <td
              :class="{ inactive: !isActive(props.item) }"
              class="text-xs-left no-wrap pointer"
            >
              {{ props.item.name }}
            </td>
            <td
              :class="{ inactive: !isActive(props.item) }"
              class="text-xs-left pointer"
            >
              {{ props.item.agencyName }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div>レポートが見れる広告主はありません</div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import SearchAndFilter from '@/components/LoginLp/Report/SearchAndFilter'
import AdvertiserRepository from '@/models/Advertiser/AdvertiserRepository'
import { mapActions } from 'vuex'
import AdvertiserApi from '@/api/AdvertiserApi'

export default {
  name: 'AdvertiserList',
  components: { SearchAndFilter },
  data() {
    return {
      sortOptions: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: -1,
      },
      advertiserList: {},
      searchAndFilter: {
        word: '',
        activeFilter: { active: true, inactive: true },
        pageNo: 1,
      },
      loading: false,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'ステータス', value: 'status', width: '10%' },
        { text: 'id', value: 'id', width: '10%' },
        { text: '名前', value: 'name' },
        { text: '代理店名', value: 'agencyName' },
      ]
    },
  },
  async created() {
    await this.setAdvertisers()
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbarSuccess: 'SHOW_SNACKBAR_SUCCESS',
    }),
    async update(pageNo) {
      this.searchAndFilter.pageNo = pageNo
      await this.setAdvertisers()
    },
    async setAdvertisers() {
      this.loading = true
      const minPermissionLevel = 'view'
      const pageSize = 100
      const res = await AdvertiserApi.fetchAdvertiserSearchList(
        minPermissionLevel,
        this.searchAndFilter.word,
        this.getFilteredStatuses(),
        pageSize,
        this.searchAndFilter.pageNo,
      )
      res['pageSize'] = pageSize
      this.advertiserList = res
      this.loading = false
    },
    getFilteredStatuses() {
      const active = this.searchAndFilter.activeFilter.active
      const inactive = this.searchAndFilter.activeFilter.inactive
      if (active && !inactive) {
        return 'active'
      } else if (!active && inactive) {
        return 'inactive'
      } else if (!active && !inactive) {
        return null
      } else {
        return undefined
      }
    },
    isActive(item) {
      return item.status === 'active'
    },
    hasAdminPermission(item) {
      return item.permission === 'admin'
    },
    goToAdvertiserReportPage(agencyId, advertiserId) {
      this.$router
        .push(
          `/agencies/${agencyId}/advertisers/${advertiserId}/standard_reports`,
        )
        .catch(() => {})
    },
    async onTextChange(keyword) {
      this.searchAndFilter.word = keyword
      await this.setAdvertisers()
    },
    async onActiveFilterChange(e) {
      const state = !this.searchAndFilter.activeFilter[e]
      this.searchAndFilter.activeFilter[e] = state
      await this.setAdvertisers()
    },
    async onClick(isActive, advertiserId) {
      const ret = await this.$confirm('ステータスを変更しますか？')
      if (!ret) return false
      this.loading = true
      try {
        if (isActive === true) {
          await AdvertiserRepository.changeStatus(advertiserId, 'inactive')
        } else {
          await AdvertiserRepository.changeStatus(advertiserId, 'active')
        }
        this.showSnackbarSuccess('広告主のステータスを変更しました。')
      } catch (e) {
        throw new Error('ステータスの変更に失敗しました。')
      } finally {
        this.loading = false
      }
      this.$emit('update')
    },
    async changeSort(header) {
      if (!header.sortable) return
      if (this.sortOptions.sortBy === header.value) {
        this.sortOptions.descending = !this.sortOptions.descending
      } else {
        this.sortOptions.sortBy = header.value
        this.sortOptions.descending = false
      }
      this.searchAndFilter.pageNo = 1
      await this.setAdvertisers()
    },
  },
}
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
}
.inactive {
  color: #aaa;
  font-style: italic;
}
</style>
